import React, { useState } from "react";

import Handshake from "../../../assets/images/icona-pag13.svg";

/* Accordion "Contesto globale / Mercato / Normativa".
   Stessa logica del Modello di Business (pointy-box + pannello flottante),
   ricolorato in oro/navy. */

const GOLD = "#f0b500";
const NAVY = "#0E3761";

const SECTIONS = [
  {
    key: "Contesto globale",
    items: [
      "Agenda 2030 delle Nazioni Unite",
      "Innovazione tecnologica e AI",
      "Tensioni geopolitiche globali",
      "Cambiamento climatico",
    ],
  },
  {
    key: "Mercato",
    items: [
      "Trend mercati assicurativi, finanziari, bancari, immobiliari",
    ],
  },
  {
    key: "Normativa",
    items: [
      <><b>Normativa assicurativa:</b> Revisione Solvency II (Direttiva UE 2025/2), CatNat (Legge 78/2025), Arbitro Assicurativo (Decreto 215/2024 e Provvedimenti IVASS), Risanamento e Risoluzione (Direttiva UE 2025/1)</>,
      <><b>Normativa ICT:</b> AI Act (Regolamento UE 2024/1689 e Legge 132/2025), Dora, Data Act (Regolamento UE 2023/2854)</>,
      <><b>Antiriciclaggio:</b> AML Package & la Nuova Autorità Europea</>,
      <><b>Fiscale e di Bilancio dello Stato:</b> Global Minimum Tax (Decreti MEF 2024-2025), Novità Fiscali Assicurative (Legge di Bilancio 2025 e 2026), Tax Control Framework (Provvedimento AE 7 agosto 2025), Incentivi alla Transizione e Occupazione (L.B. 2025)</>,
      <><b>Finanza Sostenibile e comunicazione trasparente:</b> CSRD e ESRS, Omnibus e Stop the Clock, Quick Fix, Empowering Consumers for the Green Transition, Green Claims Directive</>,
    ],
  },
];

/* Pannello flottante ancorato sopra al pointy-box */
function Panel({ title, items, onClose }) {
  return (
    <div
      className="absolute left-1/2 -translate-x-1/2 top-0 z-[40] w-[96%] max-w-[640px]"
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="relative rounded-[14px] shadow-xl border-[2px] bg-white px-5 md:px-7 py-5 max-h-[60vh] overflow-y-auto"
        style={{ borderColor: GOLD }}
        role="dialog"
        aria-label={title}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-2 text-2xl leading-none"
          style={{ color: GOLD }}
          aria-label="Chiudi"
          title="Chiudi"
        >
          –
        </button>

        <div
          className="text-left font-bold uppercase text-[14px] md:text-[20px] mb-3 pr-6"
          style={{ color: GOLD }}
        >
          {title}
        </div>

        <ul
          className="text-left text-[13px] md:text-[16px] leading-[1.35] list-disc pl-5 space-y-2"
          style={{ color: NAVY }}
        >
          {items.map((t, i) => (
            <li key={i}>{t}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function ContestoAccordion() {
  const [openKey, setOpenKey] = useState(null);
  const active = SECTIONS.find((s) => s.key === openKey);

  return (
    <div className="relative w-full mb-12 md:mb-16">
      {/* pointy-box giallo (punta verso il basso) */}
      <div
        className="pointy-box relative flex flex-col gap-3 md:gap-4 border-[5px] p-5 md:p-6 w-[400px] max-w-full h-[300px] md:h-[400px] mx-auto"
        style={{
          borderColor: GOLD,
          borderRadius: "15px 15px 50px 50px",
          "--pointy-color": GOLD,
          "--pointy-w": "36px",
          "--pointy-h": "30px",
          "--pointy-bottom": "-30px",
        }}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        {SECTIONS.map((s) => {
          const isOpen = openKey === s.key;
          return (
            <button
              key={s.key}
              type="button"
              aria-expanded={isOpen}
              onClick={() => setOpenKey(isOpen ? null : s.key)}
              className="flex items-center justify-between gap-3 font-bold uppercase text-[15px] md:text-[24px] hover:opacity-80 transition"
              style={{ color: NAVY }}
            >
              <span className="text-left">{s.key}</span>
              <span className="text-[22px] md:text-[30px] leading-none">{isOpen ? "–" : "+"}</span>
            </button>
          );
        })}

        {/* illustrazione in fondo al box */}
        <img
          src={Handshake}
          alt=""
          className="pointer-events-none select-none absolute -bottom-[26px] left-1/2 -translate-x-1/2 w-[90%]"
        />
      </div>

      {active && (
        <Panel title={active.key} items={active.items} onClose={() => setOpenKey(null)} />
      )}
    </div>
  );
}
